
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square = createMeisterIcons("square", [["path",{"fill":"currentColor","d":"M2.25 2.25h19.5v19.5H2.25zm1.5 1.5v16.5h16.5V3.75z","key":"11edbff3b4fa67aa824d1d33ef42be4807dc88f4","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square
  